/*
 * Source: https://gsmplusinfotech.com/blog/angularjs-front-end-error-logging-with-google-analytics/
 *
 * Needs: Report uncaught errors via Google Analytics
 *
 */

export default angular.module('flatastic.errorReporting', [])

.config(
    ['$provide',
    function($provide) {

  $provide.decorator('$exceptionHandler', function($delegate, $injector){
    return function(exception, cause) {
      var $rootScope = $injector.get('$rootScope');
      $delegate(exception, cause);
      if (exception.toString() === '[object Object]') {
        exception = JSON.stringify(exception);
      } else {
        exception = exception.toString();
      }
      $rootScope.$broadcast('track-event', {
        category: 'Uncaught Error',
        action: exception || '',
        label: cause || '',
      });
    };
  });
}])

.name;
